import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { logos } from "../../../services/constants";

export default function Module_1() {
    return (
        <>
            <div className="py-4">
                <h2 className="display-6 text-uppercase text-center mb-4">
                    Some of our clients
                </h2>
                <div className="d-flex flex-wrap align-items-center justify-content-center">
                    {logos.map((logo) => {
                        return (
                            <div
                                key={logo.id}
                                style={{ width: "150", height: "150" }}
                                className="mx-4 d-flex align-items-center justify-content-center"
                            >
                                <LazyLoadImage
                                    src={logo.src}
                                    className="w-100 h-100"
                                    style={{ objectFit: "contain" }}
                                    alt={logo.alt}
                                    effect="opacity"
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
